export default __webpack_public_path__ + "static/media/mastercard1.e61afcf8.svg";